// @flow @format
import {fork, take, select, put, cancel} from 'redux-saga/effects';
import {PrivateApi} from 'lib/cloner-api';
import BlocksApi from 'lib/blocks-api';
import machinesSaga from './machines';
import repositoriesSaga from './repositories';
import filesSaga from './files';
import downloadsSaga from './downloads';
import usersSaga from './users';
import {LOGIN, LOGOUT, closeSession} from '../reducers/session';

import type {State} from '../reducers';

function* rootSaga(): Generator<*, *, *> {
	while (true) {
		const state: State = yield select();

		let user,
			token,
			server = '';

		if (!state.session.isLoggedIn) {
			const {payload} = yield take(LOGIN);

			user = payload.user;
			token = payload.token;
			server = payload.server;
		} else {
			user = state.session.user;
			token = state.session.token;
			server = state.session.server;
		}

		const api = new PrivateApi(server, token);
		const blocksApi = new BlocksApi(server, token);

		const machines = yield fork(machinesSaga(api));
		const repositories = yield fork(repositoriesSaga(api));

		const files = yield fork(filesSaga(api, blocksApi));
		const users = yield fork(usersSaga(api));
		const downloads = yield fork(
			downloadsSaga(user, token, server, api, blocksApi)
		);

		yield take(LOGOUT);
		yield put(closeSession());

		yield cancel(machines);
		yield cancel(repositories);
		yield cancel(files);
		yield cancel(users);
		yield cancel(downloads);
	}
}

export default rootSaga;



// WEBPACK FOOTER //
// ./src/sagas/index.js